exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xZHKf{margin:20px}._3JQ5f{overflow:hidden;margin-bottom:15px}._3JQ5f ._13Dv-{float:left}._3JQ5f ._20JJ8{float:right}._3JQ5f ._20JJ8 button{margin-left:10px}._3Xvfx{background:#fff}._3Xvfx .ant-pagination{margin-right:15px}._2Z9O9{overflow:visible!important}._2Z9O9 span{font-size:12px}", ""]);

// exports
exports.locals = {
	"wrap": "xZHKf",
	"toolbar": "_3JQ5f",
	"toolbarLeft": "_13Dv-",
	"toolbarRight": "_20JJ8",
	"table": "_3Xvfx",
	"statusBadge": "_2Z9O9"
};